<template>
  <div class="User" @mouseenter="changeUserStatus(true)" @mouseleave="changeUserStatus(false)">
    <div class="user-box">
      <div class="avatar" @click="h5OpenNav()">
        <img class="avatar-img" :src="avatarImg" />
        <div class="icon">
          <img src="@/assets/images/renzheng@2x.png" alt />
        </div>
      </div>
      <div class="user-name txt-ellipsis">{{ user.name || 'e签宝用户' }}</div>
    </div>
    <div class="user-main" v-show="isShowUserMain">
      <div class="main-user">
        <div class="avatar">
          <img class="avatar-img" :src="avatarImg" width="40" height="40" />
        </div>
        <div class="name-info">
          <div class="name txt-ellipsis">{{ user.name || 'e签宝用户' }}</div>
          <div class="realname-status">
            <div class="realname-item" v-if="user.realnameStatus">
              <img class="realname-status-icon" src="@/assets/images/renzheng@2x.png" alt />
              <span class="text">已实名</span>
            </div>
            <div class="realname-item" v-else>
              <img class="realname-status-icon" src="@/assets/images/weirenzheng@2x.png" alt />
              <span class="text">未实名</span>
              <el-button class="realname-not-btn" @click="goRealName" type="text">立即认证</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="main-account" v-show="user.mobile || user.email">
        <div class="main-user-item txt-ellipsis" v-if="user.mobile">手机：{{ user.mobile }}</div>
        <div class="main-user-item txt-ellipsis" v-if="user.email">邮箱：{{ user.email }}</div>
      </div>
      <div class="main-hander">
        <el-button class="main-hander-btn" type="text" @click="goSaas()">
          <div class="main-hander-item">
            <i class="el-icon-goods"></i>
            <span class="main-hander-text">进入e签宝</span>
          </div>
        </el-button>
        <el-button class="main-hander-btn" type="text" @click="logout()">
          <div class="main-hander-item">
            <i class="el-icon-switch-button"></i>
            <span class="main-hander-text">退出</span>
          </div>
        </el-button>
      </div>
    </div>
    <div class="user-content-h5" v-if="openH5Nav">
      <div class="user-content-h5-list">
        <div class="user-content-h5-item" @click="goRealName()">
          <span>{{ userAndMobile }}</span>
          <span class="un-realname">{{ user.realnameStatus ? '已实名' : '未实名' }}</span>
        </div>
        <div class="user-content-h5-item" @click="goSaas()" v-if="!isEsignApp">进入e签宝</div>
        <div class="user-content-h5-item" @click="logout()" v-if="!isEsignApp">退出</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button } from 'element-ui'
import personAvatar from '@/assets/images/personAvatar.png'
import realnameMixin from '@/mixins/realname.js'
import { isInEsignApp } from '@/lib/utils'

Vue.use(Button)

export default {
  name: 'User',
  components: {},
  // filters: {},
  // directives: {},
  mixins: [realnameMixin],
  props: {
    openH5Nav: Boolean,
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isShowUserMain: false,
      isEsignApp: isInEsignApp(),
    }
  },
  computed: {
    avatarImg() {
      return this.user.head || personAvatar
    },
    userAndMobile() {
      return `${this.user.name || 'e签宝用户'}(${this.user.mobile || this.user.email})`
    },
  },
  watch: {},
  // beforeCreate() {},
  async created() {
    console.log('user', this.user)
  },
  // beforeMount() {},
  mounted() {},
  // beforeUpdate() {},
  // updated() {},
  // activated() {},
  // deactivated() {},
  // beforeDestroy() {},
  // destroyed() {},
  methods: {
    // 个人实名
    goRealName() {
      if (this.user.realnameStatus) return // this.$emit('update:openH5Nav', false)
      this.setRealName()
    },
    // 登出
    logout() {
      this.$Http
        .api({
          url: 'account-webserver/user/accounts/logout',
          method: 'POST',
        })
        .then(() => {
          this.$tsignData.logout() // 等待一下这里执行完
          // TODO 退出后的回调
          this.$emit('logout')
          this.$emit('update:openH5Nav', false)
        })
    },
    // 跳转到标准签
    goSaas() {
      this.$emit('update:openH5Nav', false)
      window.open('https://web.esign.cn', '_blank')
      // window.location.href = 'https://web.esign.cn'
    },
    // 改变状态
    changeUserStatus(flag) {
      this.isShowUserMain = flag
      // this.isShowUserMain = true
    },
    h5OpenNav() {
      this.$emit('update:openH5Nav', !this.openH5Nav)
    },
  },
}
</script>

<style lang="less" scoped>
.txt-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.1;
}
.user-content-h5 {
  display: none;
}
.User {
  position: relative;
  width: 120px;
  height: 50px;
  line-height: 56px;
  font-size: 14px;
  font-weight: 400;
  color: #cccccc;
  transition: all 0.2s ease;

  &:hover,
  &.is-acitve {
    /*color: #FFFFFF;*/
    /*font-weight: 500;*/
    background-color: #000000;
  }

  .user-box {
    display: flex;
    /*justify-content: space-around;*/
    align-items: center;
    width: 100%;
    height: 100%;

    .avatar {
      position: relative;
      margin-left: 17px;
      width: 24px;
      height: 24px;
      line-height: 0px;

      .avatar-img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }

      .icon {
        display: block;
        position: absolute;
        bottom: -3px;
        right: -5px;
        width: 14px;
        height: 14px;
      }
    }

    .user-name {
      margin-left: 15px;
      line-height: 20px;
    }
  }

  .user-main {
    // display: block !important;
    top: 50px;
    right: -3px;
    position: absolute;
    z-index: 1000;
    width: 220px;
    /*height: 301px;*/
    border-radius: 3px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);

    .main-user {
      display: flex;
      align-items: center;
      width: 100%;
      height: 72px;
      border-bottom: 1px solid #e4e4e4;

      .avatar {
        margin-left: 18px;
        width: 40px;
        height: 40px;

        .avatar-img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
      }

      .name-info {
        margin-left: 10px;
        width: 135px;

        .name {
          text-align: left;
          height: 22px;
          line-height: 22px;
          font-size: 16px;
          color: #000000;
        }

        .realname-status {
          margin-top: 3px;
          height: 17px;
          line-height: 17px;
          font-size: 12px;
          color: #a3a3a3;

          .realname-item {
            display: flex;
            align-items: center;
            /*height: 17px;*/
            /*line-height: 17px;*/
            .realname-status-icon {
              width: 14px;
              height: auto;
            }
            .realname-not-btn {
              padding: 0px;
              margin-left: 12px;
              font-size: 12px;
            }
          }

          .text {
            margin-left: 5px;
          }
        }
      }
    }

    .main-account {
      padding: 16px 23px;
      width: 100%;
      border-bottom: 1px solid #e4e4e4;
      text-align: left;

      .main-user-item {
        width: 100%;
        font-size: 14px;
        color: #4d4d4d;
        line-height: 20px;
        height: 20px;
      }

      .main-user-item + .main-user-item {
        margin-top: 13px;
      }
    }

    .main-hander {
      padding: 8px 0px;

      .main-hander-btn {
        width: 100%;
        padding: 0;
        margin: 0px;
        display: block;
        border: none;
      }

      .main-hander-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding: 0px 23px;
        height: 40px;
        line-height: 40px;
        color: #4d4d4d;
        font-size: 14px;
        font-weight: 400;

        &:hover {
          background-color: #f2f2f2;
        }

        .main-hander-icon {
          width: 16px;
          height: 16px;
          margin-right: 16px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .User {
    width: 24px;
    &:hover {
      background-color: transparent;
    }
    .user-box {
      .avatar {
        margin: 0;
      }
      .user-name,
      .avatar .icon {
        display: none;
      }
    }
    .user-main {
      display: none;
    }
  }
  .user-content-h5 {
    width: 100vw;
    left: 0;
    line-height: 20px;
    display: block;
    position: fixed;
    top: 50px;
    height: calc(100vh - 50px);
    background-color: #ffffff;
    z-index: 100001;
    .user-content-h5-list {
      flex: 1;
      font-size: 16px;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      .user-content-h5-item {
        padding: 17px 0;
        margin: 0 24px;
        border-bottom: 1px solid #e1e3e6;
        .un-realname {
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          float: right;
        }
      }
    }
  }
}
</style>
